module.exports = __webpack_public_path__ + "static/img/toTopIcon.6869d78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toTopIcon.png
// module id = zpPq
// module chunks = 1